import DataTable from 'react-data-table-component';
import { useState } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const customStyles = {
	rows: {
		style: {
			minHeight: '40px', // override the row height
				highlightOnHoverStyle: {
					backgroundColor: 'rgb(230, 244, 244)',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
		},
	},
	headCells: {
		style: {
            height: '40px',
			paddingLeft: '8px', // override the cell padding for head cells
			paddingRight: '8px',
		},
		grow: 2,
		style: {
			color: '#202124',
			fontSize: '14px',
			fontWeight: 600,
		},
	},
	cells: {
		style: {
			// paddingLeft: '8px', // override the cell padding for data cells
			// paddingRight: '8px',
		},
	},
};


// const conditionalRowStyles = [
// 	{
// 	  when: row => row.status === '1',
// 	  style: {
// 		backgroundColor: '#ECECEC',
// 	  },
// 	},
// 	// You can also pass a callback to style for additional customization
// 	// {
// 	//   when: row => row.status === '0',
// 	//   style: row => ({
// 	// 	 backgroundColor: row.isSpecia ? 'pink' : 'inerit',
// 	//   }),
// 	// },
//   ];


export const DataTableComp = ({columns, data, isIndex = false, ...rest}) => {
	const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

	const updatedColumns = [
        {
            name: 'S No.',
            selector: (_, index) => index + 1 + (currentPage - 1) * rowsPerPage,
            sortable: false,
            width: '80px',
        },
        ...columns,
    ];

    return (
        <DataTable
            pagination
			paginationPerPage={rowsPerPage} // Default rows per page
            paginationRowsPerPageOptions={[10, 20, 50, 100]} // Page size options
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                setRowsPerPage(currentRowsPerPage);
                setCurrentPage(currentPage);
            }}
            columns={isIndex?updatedColumns:columns}
            // columns={columns}
            data={data}
            customStyles={customStyles}
            sortIcon={<ArrowDropUpIcon />}
			keyField='key'
			// conditionalRowStyles={conditionalRowStyles}
        />
    );
}